import React from "react";
import Grid from "@mui/material/Grid2";

export interface ITopBarRowProps {
    spacing?: number;
    children: React.ReactNode;
}

function TopBarRow(props: ITopBarRowProps) {
    return (
        <Grid container spacing={props.spacing ?? 3} sx={{ textAlign: "center", minHeight: 80 }}>
            {props.children}
        </Grid>
    );
}

export default TopBarRow;
